module.exports = fox._r("images/empty-icon-video.png", __webpack_public_path__ + "_/_/_/common/frame/images/empty-icon-video.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/empty-icon-video.png
// module id = 94
// module chunks = 2